// extracted by mini-css-extract-plugin
module.exports = {"unauthorised":"Unauthorised_unauthorised__l7O7o","container":"Unauthorised_container__gd3pW","subHeading":"Unauthorised_subHeading__12bxs"};